__turbopack_context__.v({
  "collapsibleSection": "VehicleInterlinking-module__0pOvfa__collapsibleSection",
  "collapsibleSectionContent": "VehicleInterlinking-module__0pOvfa__collapsibleSectionContent",
  "container": "VehicleInterlinking-module__0pOvfa__container",
  "ctas": "VehicleInterlinking-module__0pOvfa__ctas",
  "section": "VehicleInterlinking-module__0pOvfa__section",
  "sectionHeading": "VehicleInterlinking-module__0pOvfa__sectionHeading",
  "sections": "VehicleInterlinking-module__0pOvfa__sections",
  "title": "VehicleInterlinking-module__0pOvfa__title",
  "viewMoreButton": "VehicleInterlinking-module__0pOvfa__viewMoreButton",
});
